import styled, { css } from "styled-components";
import React from "react";
import { colorSet } from "@common/theme";
import Button from "./Button";

export interface FilledButtonProps {
  backgroundColor?: React.CSSProperties["backgroundColor"];
  hoverBackgroundColor?: React.CSSProperties["backgroundColor"];
  color?: React.CSSProperties["color"];
  size?: "small" | "medium" | "large";
}

const FilledButton = styled(Button)<FilledButtonProps>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? colorSet.primary};
  color: ${({ color }) => color ?? "white"};
  font-weight: ${({ fontWeight }) => fontWeight ?? 500};

  &:hover {
    background-color: ${({ hoverBackgroundColor }) =>
      hoverBackgroundColor ?? colorSet.secondary};
  }

  transition: transform ease-in 0.1s;
  &:active {
    transform: scale(0.95);
  }

  ${({ size }) => {
    switch (size) {
      case "small":
        return css`
          font-size: 0.75rem;
          padding: 5px 8px;
          border-radius: 6px;
        `;
      case "medium":
      default:
        return css`
          font-size: 1rem;
          padding: 8px 12px;
          border-radius: 8px;
        `;
      case "large":
        return css`
          font-size: 1.25rem;
          padding: 10px 16px;
          border-radius: 10px;
        `;
    }
  }}
`;

export default FilledButton;
